import { saveAs } from 'file-saver';

export const screenShotHandler = ({data, filename}) => {

    try {
        saveAs(data, filename);
    } catch(e) {
        window.alert("Unable to download image. Please try again later.");
    }
}